import { render, staticRenderFns } from "./PersonRate.vue?vue&type=template&id=44ecd2a6&scoped=true"
import script from "./PersonRate.vue?vue&type=script&lang=js"
export * from "./PersonRate.vue?vue&type=script&lang=js"
import style0 from "./PersonRate.vue?vue&type=style&index=0&id=44ecd2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ecd2a6",
  null
  
)

export default component.exports